import React from 'react';
import { Typography } from '@nackle/origami';
import { AutoPlayController, Translate } from '@nackle/arcade-core-v2';
import './header.less';
// import { LocaleString } from '@nackle/intl-tools';
const { Title, Text } = Typography;

function Header(  ) {
    return (
            <div className="header-row">
                <div className="left">
                    <Title level={ 2 } style={ { fontWeight: 700 } } >
                    <Translate
                    id={ 'arcade.title.arcade' }
                    parseHtml
                  />
                    </Title>
                    <Text type="secondary">
                   <Translate
                    id={ 'arcade.webapp.play' }
                    parseHtml
                  />
                    </Text>
                </div>
                <div className="right">
                    <AutoPlayController  />
                </div>
            </div>
    );
}

export default Header;